import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { VideoTrack } from '../types/instance';

export const useVideoTracks = () => {
    const instance = usePlayerInstance();
    const [videoTracks, setVideoTracks] = useState<ReadonlyArray<VideoTrack> | undefined>(
        () => instance?.videoTracks
    );

    useInstanceEffect((instance) => instance.onVideoTracksChange(setVideoTracks));

    return videoTracks;
};
